import { createGlobalStyle } from 'styled-components';

import 'font-awesome/css/font-awesome.css';
import 'react-toastify/dist/ReactToastify.css';
const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  outline: 0;
}
.cursor-pointer{
  cursor: pointer !important
}


body, html {
  /* Fundo em cor sólida, e não no antigo radial-gradient(circle, white 10%,
     #52658c 200%). O centro daquele gradiente era BRANCO — a mesma cor dos
     cards —, então no meio da tela a borda sumia e dois cards vizinhos
     pareciam um bloco colado. Nas pontas o fundo escurecia e os mesmos cards
     voltavam a se separar: a leitura mudava conforme a posição na rolagem.
     Um cinza frio uniforme mantém a separação constante em qualquer ponto da
     página, e ainda deixa o branco disponível como cor de "coisa clicável". */
  background-color: #e9edf2;
  font-family: 'Helvetica Neue', 'Helvetica', Arial, sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  height: 100%;
  width: 100%;
  background-attachment: fixed;

}
@media print {

  body, html {
      background: transparent;
  }
}

`;

export default GlobalStyle;
